import React, { createContext, useContext } from 'react';
import { toSlug } from '@/Framework/url/helpers/toSlug';
import Router, { useRouter, getQueryString } from '@/Framework/Router';
import { IAssetClass } from '@/finsight/domain/vo/IAssetClass';
import useAssetsClasses from '../BondsSummary/useAssetClasses';

export const useTraceAssetClasses = (initial?: IAssetClass[]) => {
  const {
    assetsClasses,
    currentAssetClass,
    setCurrentAssetClass,
  } = useAssetsClasses(initial);
  const { query } = useRouter();
  const { assetClass: queryAssetClass, ...rest } = query;
  const search = getQueryString(rest);

  const handleAssetClassClick = (assetClass) => {
    const sluggedAssetClassAbbr = toSlug(assetClass.abbreviation);
    if (sluggedAssetClassAbbr !== assetClass) {
      setCurrentAssetClass(assetClass);
      Router.replace(`/trace-${ toSlug(assetClass.abbreviation) }?${ search }`, undefined, { shallow: true });
    }
  };

  return {
    assetsClasses,
    handleAssetClassClick,
    currentAssetClass,
    setCurrentAssetClass,
  };
};

type TraceAssetClassesContextType = ReturnType<typeof useTraceAssetClasses>;

export const AssetClassesContext = createContext<TraceAssetClassesContextType>(null);

export const useTraceAssetClassesContext = () => {
  const context = useContext(AssetClassesContext);
  if (!context) {
    throw new Error('useTraceAssetClassesContext must be used within the AssetClassesContext');
  }
  return context;
};

interface IProps {
  initial?: IAssetClass[],
  children: React.ReactNode,
}

const TraceAssetClassesContextProvider = ({ initial, children }: IProps) => (
  <AssetClassesContext.Provider value={ useTraceAssetClasses(initial) }>
    { children }
  </AssetClassesContext.Provider>
);

export default TraceAssetClassesContextProvider;
